import { SButton, SButtonProps, SIcon, SView, SViewProps } from './scaled'

interface Props extends SViewProps {
  backProps?: SButtonProps
  nextProps?: SButtonProps
  onBack?: () => void
  onNext?: () => void
}

const height = 45

export default function ActionButtons({ backProps, nextProps, onNext, onBack, ...rest }: Props) {
  return (
    <ActionButtonContainer {...rest}>
      {onBack ? (
        <SButton
          h={height}
          onClick={onBack}
          backgroundColor="rgba(255, 255, 255, 0.24)"
          variant="outline"
          LeftIcon={(p: any) => <SIcon value="chevron-left" {...p} />}
          {...backProps}
        >
          Back
        </SButton>
      ) : (
        <div />
      )}
      {onNext ? (
        <SButton
          h={height}
          onClick={onNext}
          color="black"
          backgroundColor="white"
          RightIcon={(p: any) => <SIcon value="chevron-right" {...p} />}
          {...nextProps}
        >
          Next
        </SButton>
      ) : null}
    </ActionButtonContainer>
  )
}

export function ActionButtonContainer(props: SViewProps) {
  return <SView direction="row" h={height} alignItems="center" justify="space-between" {...props} />
}
